import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=6cab2e5a&scoped=true&"
import script from "./dashboard.vue.js?vue&type=script&lang=js&"
export * from "./dashboard.vue.js?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=6cab2e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cab2e5a",
  null
  
)

export default component.exports